import type { ServiceModule } from '@gik/calendar/constants/services/ServiceModule';
import type { ICalendarEntry } from '@gik/calendar/models/Calendar';
import moment from 'moment';
import type { IAddToCalendarLinks } from '../components/AddToCalendarSelector';

export interface ICalendarClaim {
  id: string;
  entryId: string;
  pageTitle: string;
  recipientFullName?: string;
  /** Physical address recipient name (independent of recipientFullName). GIK-10461. */
  recipientAddressName?: string;
  pageThumbnail?: string;
  pageDescription?: string;
  pageNotes?: string;
  inkindRouteId?: string;
  pageUrl?: string;
  recipientAddress?: string;
  recipientCityAndState?: string;
  entry?: ICalendarEntry;
  supporterId: string;
  supporterBillingName?: string;
  description: string;
  note?: string;
  serviceCategorySlug: string;
  serviceModule: ServiceModule;
  serviceSlug: string;
  cartItems?: ICalendarClaimCartItem[];
  partnerUrl?: string;
  carType?: string;
  addToCalendarLinks?: IAddToCalendarLinks;
  privateClaim: boolean;
  canUserSeePrivateClaimerInfo: boolean;
}

export interface ICalendarClaimCartItem {
  imageUrl: string;
  thumbnailUrl: string;
  gridImage: string;
  price: number;
  productId: number;
  productName: string;
  variationId: number;
}

export interface IUserProfileClaim extends ICalendarClaim {
  // TODO: review which fields are optional
  pageTitle: string;
  recipientFullName: string;
  recipientAddressName: string;
  pageThumbnail: string;
  pageDescription: string;
  pageNotes: string;
  inkindRouteId: string;
  pageUrl: string;
  recipientAddress: string;
  recipientCityAndState: string;
  entry: ICalendarEntry; // required
}

const getMomentDate = (date: string) => moment.utc(date);

export function getStartDateTime(claim: IUserProfileClaim) {
  return getMomentDate(claim.entry.startsAt);
}

export function getEndDateTime(claim: IUserProfileClaim) {
  return getMomentDate(claim.entry.endsAt);
}
